import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import FindDoc from "cc-frontend/helpers/find-doc"
import type EmberStore from "cc-frontend/services/ember-store"
import type Rpc from "cc-frontend/services/rpc"
import { use } from "ember-could-get-used-to-this"
import { isString } from "lodash-es"

export default class AdminCspAllJurisdictions extends Component {
  @service("ember-store") declare store: EmberStore
  @service declare rpc: Rpc
  @service declare router
  @use jurisdictionIndex = new FindDoc(() => ["standard-jurisdiction-index-admin", "index"])

  createJurisdiction = (type) => {
    let title = window.prompt("Enter the title")
    if (isString(title) === true && title !== null && title !== undefined) {
      this.rpc
        .admin_csp_create_jurisdiction({
          type: type,
          title: title,
        })
        .then((response) => {
          if (response.responseOk === false) {
            console.log(response)
            window.alert(`Sorry! There was an error! ${response.result.message}`)
          } else {
            this.router.transitionTo("admin.csp.show", response.result.id)
          }
        })
    }
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Admin::Csp::AllJurisdictions": typeof AdminCspAllJurisdictions
  }
}
